<template>
  <div>
    <div id="All">
      <div class="all_left">
        <div class="left_top">
          <div class="actual">
            <span>Actual</span>
            <p>{{ typeValue.SELLOUT_SALES_VALUE | NumFormat }}</p>
          </div>

          <div class="sale">
            <span>{{ typeName.SELLOUT_TARGETTYPE1 }}</span>
            <p>{{ typeValue.SELLOUT_TARGET_VALUE1 | NumFormat }}</p>
          </div>

          <div class="sale">
            <span>{{ typeName.SELLOUT_TARGETTYPE2 }}</span>
            <p>{{ typeValue.SELLOUT_TARGET_VALUE2 | NumFormat }}</p>
          </div>
          <div class="sale">
            <span>{{ typeName.SELLOUT_TARGETTYPE_BTG1 }}</span>
            <p>{{ typeValue.SELLOUT_BTG1 | NumFormat }}</p>
          </div>
          <div class="sale">
            <span>{{ typeName.SELLOUT_TARGETTYPE_BTG2 }}</span>
            <p>{{ typeValue.SELLOUT_BTG2 | NumFormat }}</p>
          </div>
        </div>
      </div>
      <div class="middle"></div>
      <div class="all_right">
        <div style="display: flex; flex-direction: column">
          <Circular
            :Proportion="Proportion"
            :timeGone="timeGone"
            :textMes="textMes"
            :bindEl="bindEl"
          ></Circular>

          <div class="rightText">
            <span>
              Actual VS
              {{
                typeValue.SELLOUT_TARGET_VALUE2
                  ? typeName.SELLOUT_TARGETTYPE2
                  : typeName.SELLOUT_TARGETTYPE1
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Circular from "@/components/ButSecoend2/public/onlyCir";
export default {
  data() {
    return {
      typeName: {},
      typeValue: {},

      timeGone: "",
      textMes: "",

      Proportion: 0,
      salesValue: 0,
      targetValue: 0,
      BaToGo: 0,
      bindEl: "SellOut",
      TGG: 0,
      type: "",
      achVing: sessionStorage.getItem("achVing"),
    };
  },
  components: {
    Circular,
  },
  methods: {
    // getSum() {
    //   this.$addr
    //     // .get("http://10.216.226.81:8080/mobile_api/sellin/getSumData")
    //     .get("sellin/getSumData")
    //     .then((res) => {
    //       this.TGG =
    //         (res.data.data.targetValue * parseInt(this.achVing)) / 100 -
    //         res.data.data.salesValue;
    //       // this.Proportion = res.data.data.achieving;
    //       this.Proportion = "37.5%";
    //     });
    // },
    getType() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getTargetType")
        .get("sellinAndsellout/getTargetTypeSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            this.typeName = res.data.data[0];
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },

    getTypeData() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getTargetType")
        .get("sellinAndsellout/getSumDataSellinAndSellout")
        .then((res) => {
          if (res.data.error == 0) {
            this.typeValue = res.data.data[0];

            this.Proportion = this.typeValue.SELLOUT_TARGET_VALUE2
              ? (this.typeValue.SELLOUT_SALES_VALUE /
                  this.typeValue.SELLOUT_TARGET_VALUE2) *
                  100 +
                "%"
              : (this.typeValue.SELLOUT_SALES_VALUE /
                  this.typeValue.SELLOUT_TARGET_VALUE1) *
                  100 +
                "%";

            let timeGone = this.typeValue.weekPatternSellout
              ? this.typeValue.weekPatternSellout * 100
              : this.typeValue.timeGoneSellout * 100;
            this.timeGone = Number(timeGone).toFixed(0) + "%";

            this.textMes = this.typeValue.weekPattern
              ? "Weekly Pattern"
              : "Time Gone";
          }
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
  },
  created() {
    // this.getSum();
    this.getType();

    this.getTypeData();
  },
};
</script>
<style scoped>
#All {
  overflow: hidden;
  clear: both;
  display: flex;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}

.all_left {
  width: 225px;
  padding: 20px 19px 10px 30px;
}
.all_left .left_top {
  font-family: "微软雅黑" !important;
  font-size: 16px;
}
.all_left .left_top .sale {
  margin-bottom: 10px;
}
.actual {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 5px 0px 25px 0px;
}
.actual span {
  min-width: 83px;
  font-family: "微软雅黑" !important;
  font-size: 17px;
  color: #3a3a3b;
  text-align: right;
  font-weight: bold;
}

.rightText span {
  font-size: 17px;
  color: #3a3a3b;
  font-weight: bold;
}
.actual p {
  min-width: 100px;
  text-align: left;
  font-family: "微软雅黑" !important;
  font-size: 23px;
  color: #332a66;
  font-weight: bold;
}
.all_left .left_top .sale p {
  display: block;
  min-width: 100px;
  text-align: left;
  font-size: 15px;
  color: #332a66;
  font-weight: bold;
}
.all_left .left_top .sale {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.all_left .left_top .sale span {
  min-width: 83px;
  font-size: 13px;
  color: #3a3a3b;
  text-align: right;
  font-weight: bold;
}

.middle {
  margin: 20px 0;
  width: 1px;
  height: 164px;
  border: 1px solid rgba(157, 157, 157, 0.4);
}
.all_right {
  margin: 10px 31px 0px 19px;
  width: 187px;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.all_right p {
  font-family: "微软雅黑" !important;
  font-size: 16px;
  color: #191919;
  text-align: left;
  position: absolute;
}
</style>




// WEBPACK FOOTER //
// src/components/ButSecoend2/Summary/Sellout.vue